import React from 'react';
import { motion } from 'framer-motion';
import CancelIcon from '@mui/icons-material/Cancel';
import { SavoryGallery } from './SavoryGallery';
export function Problem() {
  const pains = ['Tardes enteras buscando recetas en redes que nunca quedan bien para el clima de Argentina.', 'Ingredientes caros desperdiciados porque la cera comestible se corta o no se derrite de forma uniforme.', 'Siempre ofreciendo lo mismo que el resto porque no tenés un catálogo innovador que impacte.', 'El efecto escururrido o el centro cremoso hechos al tanteo, sin un sistema de temperaturas.', 'Miedo a vender o a no saber cuánto cobrar por tu trabajo para no regalar tu tiempo.', 'Fin de semana agotada, frustrada y volviendo a empezar el mismo ciclo de prueba y error.'];
  return <section className="py-14 px-6 bg-brand-cream" data-id="element-240">
      <div className="max-w-3xl mx-auto" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-242">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-brand-choco-deep mb-6" data-id="element-243">
            ¿Cuántos fines de semana más vas a perder intentando adivinar?
          </h2>
          <p className="text-lg text-brand-choco/80 leading-relaxed" data-id="element-244">
            Amás las cosas ricas, las manualidades y los detalles visuales. Pero
            nadie te dijo que ibas a pasar tus tardes libres mirando videos de
            TikTok que no explican nada, tirando chocolate y manteca porque la
            mecha se apaga o la consistencia te queda dura como una piedra.
          </p>
          <p className="text-xl font-serif italic text-brand-burgundy mt-6 font-semibold" data-id="element-245">
            No es falta de talento. Es falta de un método.
          </p>
        </motion.div>

        <div className="space-y-4 bg-white p-8 rounded-2xl shadow-sm border border-brand-burgundy/10" data-id="element-246">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-3" data-id="element-247">
              <CancelIcon className="text-brand-burgundy mt-1 flex-shrink-0" fontSize="small" data-id="element-248" />
              <p className="text-brand-choco-deep/90" data-id="element-249">{pain}</p>
            </motion.div>)}
        </div>

        <SavoryGallery data-id="element-250" />

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-8" data-id="element-251">
          <h3 className="text-2xl font-serif font-bold text-brand-choco-deep" data-id="element-252">
            ¿Y si este fuera el último fin de semana que pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}